<template>
	<div class="soegning-block-app">
		<search-output v-if="initial === false && performingNewSearch === false" :force-search-top="showSearchHeader && lodgings.length !== 0" >
			<template v-if="showSearchHeader && lodgings.length !== 0" v-slot:search-top>
				<a class="go-left hidden-xs" :href="mapPage+'?type=Search'">{{translations.search.loco_search_6}} <i class="cfa cfa-map"></i></a>
				<select class="sorting go-right hidden-xs" :value="search.searchOrder" ref="search-sorter" @change="updateSearchOrder">
					<option value="default">{{translations.search.loco_search_7}}</option>
					<option value="esFromPrice">{{translations.search.loco_search_8}}</option>
					<option value="esFacility_179">{{translations.search.loco_search_9}}</option>
					<option value="esFacility_207">{{translations.search.loco_search_10}}</option>
					<option value="esFacility_9005">{{translations.search.loco_search_15}}</option>
					<option value="omraader">{{translations.search.loco_search_12}}</option>
					<option value="vejnavn">{{translations.search.loco_search_13}}</option>
				</select>
				<div class="printSmallBtn go-right hidden-xs" @click.prevent="triggerPrint">
					<print-icon />
				</div>
			</template>
		</search-output>
		<pagination v-if="fetchingPage === false && (page < maxPages || paginationType === 'page' || paginationType === 'loadMore') && performingNewSearch === false" />
		<spinner v-else-if="fetchingPage" />
	</div>
</template>

<script>
	import {mapState} from 'vuex';
	import Spinner from "@vue/components/loaders/Spinner";
	import SearchOutput from "@vue/components/search/SearchOutput";
	import Pagination from "@vue/components/search/Pagination";
	import mainSearchHandler from "@vue/mixins/mainSearchHandler";
	import PrintIcon from "@vue/components/icons/PrintIcon";
	import {setCookie} from "@js/globalFunctions/cookieHandling";
	import {triggePrintPagePost} from "@js/parts/search/functions/searchPrint";
	export default {
		name: "SoegningBlockApp",
		components: {PrintIcon, Pagination, SearchOutput, Spinner},
		mixins: [mainSearchHandler],
		data(){
			return {
				fetchingPage: false,
				searchIteration: 0,
				initial: true,
				performingNewSearch: false
			}
		},
		computed: {
			...mapState({
				lodgings: 'lodgings',
				translations: 'translations',
				page: 'page',
				maxPages: 'maxPages',
				paginationType: 'paginationType',
				isMainSearch: 'isMainSearch',
				search: 'search',
				isSeoMode: 'isSeoMode',
				showSearchHeader: 'showSearchHeader',
				mapPage: 'mapPage',
				printIds: 'printIds'
			}),
			queryParameters(){
				return this.search.queryParameters;
			}
		},
		methods: {
			triggerPrint(e){
				triggePrintPagePost(this.printIds.join(','));
			},
			updateSearchOrder(e){
				this.$store.commit('setSearchOrder',e.target.value);
				if(this.isMainSearch)
					setCookie('searchOrder',e.target.value,2);

				this.performingNewSearch = true;
				this.$nextTick(() => {
					this.$store.commit('setPage',1);
					this.fetchPage(true);
				})
			},
			fetchPage(overwrite){
				overwrite = typeof overwrite !== 'boolean' ? true : overwrite;
				this.fetchingPage = true;
				this.searchIteration++;
				const localIteration = this.searchIteration+0;

				//Allow users a 200ms time to type in their next character between searches.
				setTimeout(() => {
					if(this.searchIteration === localIteration)
					{
						this.$store.dispatch('performSearch',{overwrite: overwrite, fetchAll: this.initial && this.paginationType === 'infinite'})
						.then(response => {
							if(this.isMainSearch)
							{
								this.triggerSearchFinishedEvents(this.initial,this.performingNewSearch);
							}
							this.fetchingPage = false;
							this.initial = false;
							this.performingNewSearch = false;
						})
						.catch(error => {
							console.log(error)
							this.fetchingPage = false;
							this.initial = false;
							this.performingNewSearch = false;
						})

					}
				},300)
			}
		},
		mounted()
		{
			if(!this.isMainSearch)
				this.fetchPage();
		},
		watch:{
			page(){
				if(this.performingNewSearch)
					return;
				if(this.isSeoMode)
				{
					const regex = /\/page\/([0-9]+)\//i;
					window.location = window.location.href.replace(regex,'/page/'+this.page+'/');
				}
				else
				{
					this.fetchPage(this.paginationType === 'page');
				}

			},
			queryParameters:{
				deep: true,
				handler: function(){
					if(this.initial === false)
					{
						this.performingNewSearch = true;
						this.$nextTick(() => {
							this.$store.commit('setPage',1);
							this.fetchPage(true);
						})

					}

				}
			}
		}
	};
</script>

<style lang="scss" scoped>
	.soegning-block-app{
		.pagination{
			margin-top: 10px;
		}
	}
</style>
